import { Component } from '@angular/core';
import { AnyoTableComponent } from 'projects/app-core/src/app/models/AnyoTableComponent';
import { EventsFeedbackGridResponseData } from '../../../models/events/eventsFeedbackGridResponse';
import { EventsFeedbackFilter, EventsFeedbackGridRequest } from '../../../models/events/eventsFeedbackGridRequest';
import { AnyoSortDirection } from 'projects/app-core/src/models/gridRequest';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { EventsService } from '../../../services/events.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';

interface CheckBoxOptions {
  label: string;
  value: string;
  checked: boolean;
}

@Component({
  selector: 'app-events-feedback',
  templateUrl: './events-feedback.component.html',
  styleUrl: './events-feedback.component.scss'
})
export class EventsFeedbackComponent extends AnyoTableComponent<EventsFeedbackGridResponseData,EventsFeedbackGridRequest> {
  eventsCheckBoxOptions: CheckBoxOptions[] = [];
 
  verticals: CheckBoxOptions[] = [];
  concerns: CheckBoxOptions[] = [];

  globalSearchInput = '';

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  sortTherapistRating(sort: string | null) {
    this.gridRequest!.sort = {
      RATING: undefined,
    };
    if (sort) {
      this.gridRequest!.sort!.RATING =
        sort === 'ascend' ? AnyoSortDirection.ASC : AnyoSortDirection.DESC;
    } else {
      this.gridRequest!.sort!.RATING = AnyoSortDirection.ASC;
    }
    this.getData();
  }

  constructor(
    protected override auth: AuthService,
    protected toast: ToastService,
    private events: EventsService,
    public utils: UtilsService,
  ) {
    super(auth, toast);
  }
  override async getData(): Promise<void> {
    this.pageLoading = true;
    if (!this.gridRequest.filters) {
      this.gridRequest.filters = {
        TEST: [this.testTherapistDisplay.toString()],
        PLAN_ID: undefined,
        VERTICAL_ID: undefined,
        CONCERN_ID: undefined,
      };
    }
    this.gridRequest.filters.TEST = [this.testTherapistDisplay.toString()];

    this.events.getEventsFeedbackGrid(this.gridRequest).subscribe({
      next: (value) => {
        this.eventsCheckBoxOptions = value.filterOptions.events.map((stat) => {
          if (this.gridRequest.filters?.EVENT_ID?.includes(stat)) {
            return {
              label: stat,
              value: stat,
              checked: true,
            };
          } else {
            return {
              label: stat,
              value: stat,
              checked: false,
            };
          }
        });
      
        this.data = value.data;
        this.totalCount = value.totalRecords;
        this.pageLoading = false;
      },
      error: (err) => {
        this.pageLoading = false;
        const errorBody = err.error as IAnyoError;
        this.toast.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  eventFilter(event: string[]) {
    if (event && event.length) {
      if (!this.gridRequest!.filters) {
        this.gridRequest!.filters = {
          [EventsFeedbackFilter.EVENT_ID]: [],
          [EventsFeedbackFilter.TEST]: [],
        };
      }
      this.gridRequest!.filters.EVENT_ID = event;
    }
  }


  searchGlobal() {
    if (this.globalSearchInput.length) {
      this.gridRequest.globalSearch = [];
      this.gridRequest?.globalSearch?.push(this.globalSearchInput.trim());
      this.getData();
    }
  }
  testTherapistDisplay = false;
  testTherapistChangeFn($event: boolean) {
    this.testTherapistDisplay = $event;
    this.currentPageNo = 1;
    this.gridRequest = {
      page: 1,
      pageSize: this.pageSize,
      export: false,
      filters: {
        TEST: [$event.toString()],
        EVENT_ID: undefined,
      },
    };
    this.getData();
  }

  override async resetFilter(): Promise<void> {
    this.gridRequest = {
      dateFilters: undefined,
      export: false,
      filters: undefined,
      from: undefined,
      globalSearch: [],
      searchQuery: undefined,
      sort: undefined,
      to: undefined,
      page: 1,
      pageSize: this.pageSize,
    };
    this.globalSearchInput = '';
    this.getData();
  }
}
